import { IPublicClientApplication } from '@azure/msal-browser';
import { dvList, dvCreate, dvUpdate } from '../api/dataverseClient';
import { PortalConfig, ClientProjectAccess } from '../types';

export async function getPortalConfig(pca: IPublicClientApplication, projectId: string): Promise<PortalConfig | null> {
  const list = await dvList<PortalConfig>(pca, 'dagrun_pm_portalconfigs', {
    select: ['dagrun_pm_portalconfigid','dagrun_pm_name','dagrun_pm_isenabled','dagrun_pm_sectionsconfigjson','_dagrun_pm_projectid_value'],
    filter: `_dagrun_pm_projectid_value eq ${projectId}`,
    top: 1,
  });
  return list[0] ?? null;
}

export async function createPortalConfig(pca: IPublicClientApplication, projectId: string): Promise<string> {
  return dvCreate(pca, 'dagrun_pm_portalconfigs', {
    dagrun_pm_name: 'Portal Config',
    dagrun_pm_isenabled: false,
    dagrun_pm_sectionsconfigjson: JSON.stringify({ tasks: true, issues: true, milestones: true, documents: true, goals: false }),
    'dagrun_pm_projectid@odata.bind': `/dagrun_pm_projects(${projectId})`,
  });
}

export async function updatePortalConfig(pca: IPublicClientApplication, id: string, patch: Record<string, unknown>): Promise<void> {
  return dvUpdate(pca, 'dagrun_pm_portalconfigs', id, patch);
}

export async function getClientAccess(pca: IPublicClientApplication, projectId: string): Promise<ClientProjectAccess[]> {
  return dvList<ClientProjectAccess>(pca, 'dagrun_pm_clientprojectaccesses', {
    select: ['dagrun_pm_clientprojectaccessid','dagrun_pm_grantedon','dagrun_pm_grantedby','_dagrun_pm_contactid_value','_dagrun_pm_projectid_value'],
    filter: `_dagrun_pm_projectid_value eq ${projectId}`,
  });
}
